// Works for football only
import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

import type { Position } from '@sorare/core/src/__generated__/globalTypes';
import { PositionIcon } from '@sorare/core/src/components/lineup/PositionIcon';
import { FILTERS } from '@sorare/core/src/lib/filters';
import type { PlayablePosition } from '@sorare/core/src/lib/players';
import {
  anyPositionNames,
  formatPosition,
  sortByPosition as sortByPositionFn,
} from '@sorare/core/src/lib/players';

import {
  makeBackendFilter,
  makeFilter,
} from '#src/searchCards/RefineList/index.tsx';

const sortByPosition = (items: RefinementListItem[]) => {
  return items.sort((a, b) =>
    sortByPositionFn(b.value as PlayablePosition, a.value as PlayablePosition)
  );
};

export const RefinePosition = ({ hideTitle }: { hideTitle?: boolean } = {}) =>
  makeFilter(FILTERS.position, {
    formatOption: formatPosition,
    transformItems: sortByPosition,
    renderBefore: (o: string) => <PositionIcon position={o as Position} />,
    hideTitle,
  });

export const RefineBackendPosition = ({
  hideTitle,
}: { hideTitle?: boolean } = {}) =>
  makeBackendFilter(FILTERS.position, {
    formatOption: formatPosition,
    transformItems: sortByPosition,
    renderBefore: (o: string) => <PositionIcon position={o as Position} />,
    hideTitle,
  });

// Works for all sports (football, MLB, NBA)
export const RefineBackendAnyPosition = ({
  hideTitle,
}: { hideTitle?: boolean } = {}) =>
  makeBackendFilter(FILTERS.position, {
    formatOption: (pos, fmt) => {
      const msg = anyPositionNames[pos as Position];
      return msg ? fmt(msg) : pos;
    },
    hideTitle,
  });
